module.exports = __webpack_public_path__ + "img/3.108aa1d7.jpg";